/** @ngInject */
export function Controller(AuthenticationSharedService) {
        AuthenticationSharedService.logout();
}



// WEBPACK FOOTER //
// ./src/portal/states/public/logout/logout.controller.js